/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
export const ActionTypes = {
  QUEUE_FETCH: 'QUEUE_FETCH',
  START_FETCH: 'START_FETCH',
  SUCCESS_FETCH: 'SUCCESS_FETCH',
  FAILURE_FETCH: 'FAILURE_FETCH'
};

/**
 * Creates an action for queueing a fetch request. This is the primary method
 * of triggering a new fetch lifecycle.
 *
 * @returns {{type: string}}
 */
export function queueFetch() {
  return {
    type: ActionTypes.QUEUE_FETCH
  };
}

/**
 * Creates an action for the start of a fetch request.
 *
 * @returns {{type: string}}
 */
export function startFetch() {
  return {
    type: ActionTypes.START_FETCH
  };
}

/**
 * Creates an action for the success of a fetch request.
 *
 * @param {Object.<string, *>} data the order data fetched
 * @returns {{payload: {data: Object.<string, *>, receivedAt: number}, type: string}}
 */
export function successFetch(data) {
  return {
    type: ActionTypes.SUCCESS_FETCH,
    payload: {
      data,
      receivedAt: Date.now()
    }
  };
}

/**
 * Creates an action for the failure of a fetch request.
 *
 * @param {ErrorType} error the error that occurred
 * @returns {{payload: ErrorType, type: string}}
 */
export function failureFetch(error) {
  return {
    type: ActionTypes.FAILURE_FETCH,
    payload: error
  };
}
